(function() {
  if (!window.theme || !window.theme.cart) return;

  var REQUIRED_CATEGORIES = ['Dres', 'Hlače', 'Dodatek'];
  var DISCOUNT_CODE_PROPERTY = '_alpe_bundle_discount_code';
  var enforcementPromise = null;

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function lineProperties(line) {
    return line && line.properties && typeof line.properties === 'object'
      ? line.properties
      : {};
  }

  function getIncompleteBundleTargets(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var groups = new Map();

    items.forEach(function(line) {
      var properties = lineProperties(line);
      var bundleId = properties._alpe_bundle_id;
      var discountCode = properties[DISCOUNT_CODE_PROPERTY];

      if (!bundleId || !discountCode || Number(line.quantity || 0) < 1) return;

      if (!groups.has(bundleId)) {
        groups.set(bundleId, { categories: new Set(), lines: [] });
      }

      var group = groups.get(bundleId);
      group.categories.add(String(properties.Kategorija || ''));
      group.lines.push({
        bundleId: String(bundleId),
        category: String(properties.Kategorija || ''),
        variantId: String(line.variant_id || line.id || '')
      });
    });

    var targets = [];
    groups.forEach(function(group) {
      var complete = REQUIRED_CATEGORIES.every(function(category) {
        return group.categories.has(category);
      });
      if (!complete) targets = targets.concat(group.lines);
    });

    return targets;
  }

  function findCurrentLine(cart, target) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.find(function(line) {
      var properties = lineProperties(line);
      return String(properties._alpe_bundle_id || '') === target.bundleId
        && String(properties.Kategorija || '') === target.category
        && String(line.variant_id || line.id || '') === target.variantId
        && Boolean(properties[DISCOUNT_CODE_PROPERTY]);
    });
  }

  function updateLineWithoutBundleDiscount(line) {
    var properties = Object.assign({}, lineProperties(line));
    delete properties[DISCOUNT_CODE_PROPERTY];

    return fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: line.key,
        quantity: Number(line.quantity || 0),
        properties: properties
      })
    }).then(function(response) {
      if (!response.ok) throw new Error('Bundle integrity update failed');
      return response.json();
    });
  }

  function enforceBundleIntegrity(cart) {
    if (enforcementPromise) return enforcementPromise;

    enforcementPromise = Promise.resolve(cart || theme.cart.getCart())
      .then(function(currentCart) {
        var targets = getIncompleteBundleTargets(currentCart);
        if (!targets.length) return { cart: currentCart, changed: false };

        var workingCart = currentCart;
        var sequence = Promise.resolve();

        targets.forEach(function(target) {
          sequence = sequence.then(function() {
            var currentLine = findCurrentLine(workingCart, target);
            if (!currentLine) return;
            return updateLineWithoutBundleDiscount(currentLine).then(function(updatedCart) {
              workingCart = updatedCart;
            });
          });
        });

        return sequence.then(function() {
          return { cart: workingCart, changed: true };
        });
      })
      .finally(function() {
        enforcementPromise = null;
      });

    return enforcementPromise;
  }

  function refreshCartAfterIntegrity(result) {
    if (!result || !result.changed) return;
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: result.cart, bundleIntegrityChecked: true }
    }));
  }

  function runInitialCheck() {
    theme.cart.getCart()
      .then(enforceBundleIntegrity)
      .then(refreshCartAfterIntegrity)
      .catch(function() {});
  }

  theme.cart.getIncompleteBundleTargets = getIncompleteBundleTargets;
  theme.cart.enforceBundleIntegrity = enforceBundleIntegrity;

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.bundleIntegrityChecked) return;
    enforceBundleIntegrity(event.detail && event.detail.cart)
      .then(refreshCartAfterIntegrity)
      .catch(function() {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialCheck, { once: true });
  } else {
    runInitialCheck();
  }

  window.addEventListener('pageshow', runInitialCheck);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') runInitialCheck();
  });
})();
